/**
 * 機能(ライセンス)で画面を出し分ける。
 *
 * **ここは見た目の出し分けだけ。** 実際の関門は API 側(`require_feature`)が持つ。
 * `me` がまだ来ていない間は「無い」に倒す — 後から項目が増える方が、押したら
 * 403 になる項目を見せるより安全(ロールの出し分けと同じ考え方)。
 */
import type { Me } from "./api";

/** `required` が文字列なら 1 つ、配列なら「どれか 1 つでも」有効か。 */
export function hasFeature(me: Me | undefined, required: string | string[]): boolean {
  if (!me?.features) return false;
  const want = Array.isArray(required) ? required : [required];
  return want.some((key) => me.features.includes(key));
}

/** 期限切れ(猶予も過ぎた)= 参照だけできる状態か。 */
export function isReadOnly(me: Me | undefined): boolean {
  return me?.license?.read_only === true;
}
